import { Ref, RefString, RefNumber, RefDate } from "@tblabs/truffle";
import { StepData } from "../../Step/StepData";
import { PaymentForm } from "../../../Models/Payment/PaymentForm";
import { PaymentCategory } from "../../../Models/Payment/PaymentCategory";
import { PaymentStepRawData } from "./PaymentStepRawData";
import { PaymentStepState } from "./PaymentStepState";


export class PaymentStepData extends StepData
{
    public Category = new Ref<PaymentCategory>(PaymentCategory.Unset);
    public AccountNumber = new RefString();
    public Title = new RefString();
    public Amount = new RefNumber(0);
    public Currency = new RefString("PLN");
    public PaymentCurrency = new RefString("PLN");
    public ExchangeRate = new RefNumber(0);
    public Form = new Ref<PaymentForm>(PaymentForm.Unset);
    public Deadline = new RefDate(0);
    public WhenPaid = new RefDate(0);
    public Comment = new RefString();
    public CancellationReason = new RefString();

    constructor(raw: Partial<PaymentStepRawData>)
    {
        super(raw);

        this.State.value ||= PaymentStepState.Awaiting;

        this.Category.value = raw?.Category || PaymentCategory.Unset;
        this.AccountNumber.value = raw?.AccountNumber || "";
        this.Title.value = raw?.Title || "";
        this.Amount.value = raw?.Amount || 0;
        this.Currency.value = raw?.Currency || "PLN";
        this.PaymentCurrency.value = raw?.PaymentCurrency || "PLN";
        this.ExchangeRate.value = raw?.ExchangeRate || 0;
        this.Form.value = raw?.Form || PaymentForm.Unset;
        this.Deadline.value = new Date(raw?.Deadline || 0);
        this.WhenPaid.value = new Date(raw?.WhenPaid || 0);
        this.Comment.value = raw?.Comment || "";
        this.CancellationReason.value = raw?.CancellationReason || "";
    }

    public get AmountAsString(): string
    {
        return this.Amount.value.toString() + " " + this.Currency.value;
    }
}
